import { message } from 'antd';
import _copy from 'copy-to-clipboard';

export function useAntMessage() {
  const [messageInstance, messageContextHolder] = message.useMessage();
  function copy(content: string, successText?: string) {
    const flag = _copy(content, { format: 'text/plain' });
    if (flag) messageInstance.success(successText || '已复制', 1);
  }

  return {
    messageInstance,
    messageContextHolder,
    copy,
  };
}
